import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMathGreaterThan: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"math-greater-than, >"} maskId="square-filled-radius-0-stroke-1-IconMathGreaterThan"><path fillRule="evenodd" clipRule="evenodd" d="M5.23437 5.34473L19.7833 11.5L5.23437 17.6553L4.84473 16.7344L17.2168 11.5L4.84473 6.26569L5.23437 5.34473Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMathGreaterThan;
